import type { Store } from '@reduxjs/toolkit'
import type { Persistor } from 'redux-persist'

const storeRef: { current: Store | null } = { current: null }

// Set alongside storeRef when the store boots. Lets non-React modules force
// redux-persist to write pending state to storage (persistor.flush()) before a
// hard reload — persist writes are throttled/async, so a same-tick reload can
// otherwise lose them.
export const persistorRef: { current: Persistor | null } = { current: null }

export default storeRef
